import React from 'react'
import Box from '@mui/material/Box'
import Button from '@mui/material/Button'
import Typography from '@mui/material/Typography'
import ArrowUpIcon from '@mui/icons-material/ArrowUpward'
// import ArrowUpIcon from '@mui/icons-material/Publish'
// import ArrowUpIcon from '@mui/icons-material/VerticalAlignTop'
import { scrollTop } from '../modules/util'

interface Props {
  label?: string
}

/**
 * ページの先頭に戻るボタン
 */
export const BackToPageTop: React.FC<Props> = (props) => {
  const label = props.label ? props.label : 'ページの先頭に戻る'

  return (
    <Box
      sx={{
        mt: 4,
        mb: 2,
        textAlign: 'center',
      }}
    >
      <Button
        onClick={() => { scrollTop() }}
      >
        <Box
          sx={{
            display: 'flex'
          }}
        >
          <ArrowUpIcon />
          <Typography component='span'>{label}</Typography>
        </Box>
      </Button>
    </Box>
  )
}
export default BackToPageTop
